import { useQuery } from '@tanstack/react-query';

import { HintCoverageGridParams, getHintCoverageGrid } from '~/services/ConnectionGoogleService';

export const hintCoverageGridQueryKeys = {
  all: ['hintCoverageGrid'] as const,
  grid: (params: HintCoverageGridParams) => [...hintCoverageGridQueryKeys.all, 'grid', params] as const,
};

export function useGetHintCoverageGrid(params: HintCoverageGridParams) {
  return useQuery({
    queryKey: hintCoverageGridQueryKeys.grid(params),
    queryFn: async ({ signal }) => {
      const response = await getHintCoverageGrid(params, { signal });
      return response.result;
    },
    enabled: !!params.accountType,
  });
}
